export const unauthorisedStatusCodes = ['401', 401, '419', 419];

export const tooManyRequestsStatusCodes = ['429', 429];
